import { Diary } from "../../models/diary"
import { User } from "../../models/user"

export namespace Diaries 
{

    export class UserLoggedIn
    {
        static readonly type = "[Diary Login Action] Successful Login";
        constructor(public payload: { user: User }) {}
    }

    export class DiaryServiceDiaryAssigned
    {
        static readonly type = "[Diary Service] Diary Assigned";

        constructor(public payload: {diaryId: number, userId: number}){}
    }

    export class EncounterServiceDiaryAssigned
    {
        static readonly type = "[Encounter Service] Diary Assigned";

        constructor(public payload: {diaryId: number, userId: number}){}
    }

    export class EncounterServiceDiaryCreated
    {
        static readonly type = "[Encounter Service] Diary Created";
        constructor(public payload: {diaryId: number, diary: Diary}){}
    }

    export class EncounterServiceDiaryClosed
    {
        static readonly type = "[Encounter Service] Diary Closed";
        constructor(public payload: {diaryId: number}){}
    }

    export class DiaryManagerLookbackChanged
    {
        static readonly type="[Diary Manager] Lookback Changed";
        constructor(public payload:{lookback: number}){}
    }

    export class DiaryManagerLookaheadChanged
    {
        static readonly type="[Diary Manager] Lookahead Changed";
        constructor(public payload:{lookahead: number}){}
    }

    export class RefreshOpenDiaries
    {
        static readonly type="[Diary State] Refresh Open Diaries";
        constructor(){}
    }

    export class RefreshClosedDiaries
    {
        static readonly type="[Diary State] Refresh Closed Diaries";
        constructor(){}
    }

    export class EncounterServiceDiaryUpdated
    {
        static readonly type="Diary Updated";
        constructor(public payload:{diaryId: number, diary: Diary}){}
    }
}